import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { userMessages } from 'src/features/users/utils/messages';
import { ChangeUserPasswordFormSchemaValues } from 'src/features/users/utils/formSchema';

type UserFormProps = {
    form: UseFormReturn<ChangeUserPasswordFormSchemaValues>;
    onSubmit: (values: ChangeUserPasswordFormSchemaValues) => void;
};

function ChangeUserPasswordUserForm({ onSubmit, form }: UserFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ChangeUserPasswordFormSchemaValues>
                form={form}
                name="password"
                type="password"
                label={formatMessage(userMessages.password)}
            />
            <InputFormField<ChangeUserPasswordFormSchemaValues>
                form={form}
                name="password_confirm"
                type="password"
                label={formatMessage(userMessages.confirmPassword)}
            />
        </Form>
    );
}

export default ChangeUserPasswordUserForm;
